import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Spin from 'components/Spin';
import { WithStyles } from 'decorators/withStyles';
import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';

import type { ICDFFiles } from 'store/Orbita/FiscalDocuments/interfaces';

interface IPropsFromConnect {
  isFetching: boolean;
  items: ICDFFiles;

  classes?: any;
}

@WithStyles({
  emptyMessage: {
    textAlign: 'center',
    paddingTop: 20,
  },
  button: {
    textTransform: 'capitalize',
  },
  status: {
    fontStyle: 'italic',
    opacity: 0.5,
    marginTop: '-4px',
    display: 'block',
    fontSize: '12px',
  },
})
class Files extends PureComponent<IPropsFromConnect> {
  icons = {
    jpeg: 'collections',
    jpg: 'collections',
    png: 'collections',
    gif: 'collections',
    pdf: 'picture_as_pdf',
  };

  statuses = [undefined, 'Aguardando Aprovação', 'Aprovado', 'Reprovado'];

  getIcon = (ext: string) => {
    return this.icons[ext] || 'attach_file';
  };

  render() {
    const { isFetching, items, classes } = this.props;

    if (isFetching) {
      return <Spin />;
    }

    if (!items.length) {
      return <p className={classes.emptyMessage}>Nenhum registro encontrado.</p>;
    }

    return (
      <Fragment>
        {items.map((item) => (
          <Button key={item.id} href={item.url} target='_blank' fullWidth className={classes.button}>
            <Grid container spacing={2} alignItems='center'>
              <Grid item xs={false}>
                <Icon>{this.getIcon(item.ext)}</Icon>
              </Grid>
              <Grid item xs={true}>
                <p>{item.name}</p>
                <div className='m8' />
                <small className={classes.status}>{this.statuses[Number(item.status)] || 'Pendente'}</small>
              </Grid>
            </Grid>
          </Button>
        ))}
      </Fragment>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    isFetching: state.orbita.FiscalDocuments.details.isFilesFetching,
    items: state.orbita.FiscalDocuments.details.files || [],
  };
}

export default connect<IPropsFromConnect, {}, {}>(mapStateToProps)(Files);
